import React, {Component} from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleAlert from "../../../../../modules/popup/SimpleAlert";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleDate from "../../../../../modules/SimpleDate";
import SimpleInput from "../../../../../modules/SimpleInput";
import ReceivingUnitDGIProcess from "./receivingUnitDGIProcess";
import Api from "../../../../../Services/Api";
import * as R from "ramda";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import { defaultTableChange } from "../../../../../modules/custom/customTable";

class ReceivingUnitDGIDetail extends Component {
    tableColumns = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, {rowIndex}) => <>{rowIndex + 1}</>,
                setCellProps: () => ({
                    style: {width: "5%"},
                }),
            },
        },
        {
            name: "kodeVarian",
            label: "Kode Varian",
        },
        {
            name: "frameNumber",
            label: "Rangka",
        },
        {
            name: "engineNumber",
            label: "No. Mesin",
        },
        {
            name: "namaWarnaPabrik",
            label: "Warna",
        },
    ];

    constructor(props) {
        super(props);
        this.selectedData = props.state.selectedData;
        this.totalNonEditable =
            this.selectedData.listUnitDetail.length > 0 &&
            this.selectedData.listUnitDetail.filter((u) => !u.editable);
        this.state = {
            alertVisible: false,
            processModalVisible: false,
            loading: false,
            missingColorAlert: false,
            missingColorList: [],
            pagination: {
                page: 1,
                limit: 5,
                totalData: this.selectedData.listUnitDetail.length,
            },
        };
    }

    handleCloseMissingAlert = () => {
        this.setState({missingColorAlert: false, missingColorList: []});
    };

    handleProcess = async () => {
        const {listUnitDetail} = this.selectedData;

        const missingList = listUnitDetail
            .filter(i => R.isNil(i.idWarna))
            .map(i => i.engineNumber);

        const missingAlert = missingList.length > 0;
        if (missingAlert) {
            this.setState({missingColorAlert: missingAlert, missingColorList: missingList});
            return;
        }


        const editableUnit =
            this.selectedData.listUnitDetail.length > 0 &&
            this.selectedData.listUnitDetail.filter((u) => u.editable);
        if (editableUnit.length > 0) {
            this.setState((prevValue) => ({...prevValue, loading: true}));
            const listNosin = editableUnit.map((u) => u.engineNumber);
            await Api.create("NAGAMAS_TRANSACTION").validateReceivingDGIDetail(listNosin);
            this.setState((prevValue) => ({...prevValue, alertVisible: true, loading: false}));
            return;
        }

        this.handleProcessVisibility();
    };

    handleProcessVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            processModalVisible: !prevValue.processModalVisible,
        }));
    };

    handleAlertModalVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            alertVisible: false,
            processModalVisible: !prevValue.processModalVisible,
        }));
    };

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        return (
            <>
                <SimpleModal
                    title="Detail Penerimaan Unit - DGI"
                    visible={this.props.state.detailVisible}
                    onClickClose={this.props.onShowModal}
                    content={
                        <ModalContainer>
                            <div
                                className="grid grid-2x grid-mobile-none gap-15px"
                                style={{alignItems: "center"}}
                            >
                                <div id="grid-1">
                                    <SimpleDate
                                        id="select_date_tanggal_sl"
                                        label="Tanggal SL"
                                        date={this.selectedData.slDate}
                                        disabled
                                    />
                                    <SimpleInput
                                        id="input_text_nosl"
                                        name="nosl"
                                        label="No. SL"
                                        readOnly
                                        value={this.selectedData.slNo}
                                    />
                                </div>
                                <div id="grid-2">
                                    <SimpleInput
                                        id="input_text_noinvoice"
                                        name="noinvoice"
                                        label="No. Invoice"
                                        readOnly
                                        value={this.selectedData.noInvoice}
                                    />
                                    <SimpleInput
                                        id="input_text_jumlah"
                                        name="jumlah"
                                        label="Jumlah"
                                        value={this.selectedData.listUnitDetail.length}
                                        readOnly
                                    />
                                </div>
                            </div>
                            <h3 className="margin-bottom-10px">Detail Penerimaan :</h3>
                            <SimpleDataTable
                                key={`${this.state.pagination.totalData}-${this.state.pagination.page}`}
                                data={this.selectedData.listUnitDetail}
                                columns={this.tableColumns}
                                toCount={this.state.pagination.totalData}
                                rowsPerPage={this.state.pagination.limit}
                                page={this.state.pagination.page - 1}
                                options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                            />
                            <br/>
                            {this.props.state.actionType == "proses" &&
                                <FlexView hAlignContent="right" style={{gap: "10px"}}>
                                    <SimpleButton type="button" onClick={() => this.handleProcess()}>
                                        Proses
                                    </SimpleButton>
                                </FlexView>
                            }
                        </ModalContainer>
                    }
                />
                {this.state.processModalVisible && (
                    <ReceivingUnitDGIProcess
                        data={this.selectedData}
                        visible={this.state.processModalVisible}
                        onCloseDetail={(action) => this.props.onShowModal(action)}
                        onClickClose={() => this.handleProcessVisibility()}
                    />
                )}
                {this.state.alertVisible && (
                    <SimpleAlert
                        visible={this.state.alertVisible}
                        onClickClose={this.handleAlertModalVisibility}
                        content={
                            <p>
                                Ada {this.totalNonEditable.length}/{this.selectedData.listUnitDetail.length} data
                                Noka atau Nosin yang sudah ada di NOS.
                            </p>
                        }
                        additionalButtons={
                            <SimpleButton onClick={this.handleAlertModalVisibility}>OK</SimpleButton>
                        }
                    />
                )}
                {this.state.missingColorAlert && (
                    <SimpleAlert
                        visible={this.state.missingColorAlert}
                        title="Informasi"
                        onClickClose={this.handleCloseMissingAlert}
                        content={
                            <div>
                                {this.state.missingColorList.map(i => {
                                    return <p>{i}</p>
                                })}
                                <p>Nomor Mesin diatas tidak memiliki warna terdaftar.</p>
                                <p>Silakan tambahakan warna di masterdata terlebih dahulu</p>
                            </div>
                        }
                        additionalButtons={
                            <SimpleButton onClick={this.handleCloseMissingAlert}>OK</SimpleButton>
                        }
                    />
                )}
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    }
}

export default ReceivingUnitDGIDetail;
